import { KyronClient } from '../components/utils/KyronClient';
import { Role } from './types';

export async function getRoles(): Promise<Role[]> {
  const client = new KyronClient();
  return await client.getDataWithError(`/api/v1/roles`);
}
